import { QuoteVariableConfiguration } from '@interfaces/quote-variable-configurations';
import { getCall } from '@services/rest-service';

// Retrieves all the quote variable configurations from cosmos
export const getQuoteVariableConfigurations = (): Promise<QuoteVariableConfiguration[]> => {
  return getCall<QuoteVariableConfiguration[]>('quote-variable-configurations');
};
